import {
  getUser,
  getVendor,
  getUserToken,
  getVendorToken,
  setUserSession,
  setVendorSession,
  resetUserSession,
  resetVendorSession
} from "./service/AuthService";
import React, { useEffect, useState } from "react";
import Home from "./components/routes/Home";
import Partnerships from "./components/routes/Partnerships";
import About from "./components/routes/About";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import axios from "axios";
import SignUp from "./components/routes/accounts/users/SignUp";
import Footer from "./components/footers/Footer";
import PlatformsMain from "./components/routes/platforms/index";
import Adashi from "./components/routes/platforms/Adashi";
import Shopping from "./components/routes/platforms/Shopping";
import Feeding from "./components/routes/platforms/Feeding";
import Services from "./components/routes/platforms/Services";
import VServices from "./components/routes/vendors/Services";
import Rentals from "./components/routes/platforms/Rentals";
import ChildCare from "./components/routes/platforms/ChildCare";
import Health from "./components/routes/platforms/Health";
import Travel from "./components/routes/platforms/Travel";
import Payment from "./components/routes/platforms/Payment";
import SignIn from "./components/routes/accounts/users/SignIn";
import HomePage from "./components/routes/accounts/users/HomePage";
import Sellers from "./components/routes/vendors/Sellers";
import Properties from "./components/routes/vendors/Properties";
import VSignIn from "./components/routes/accounts/vendors/VSignIn";
import VSignUp from "./components/routes/accounts/vendors/VSignUp";
import VHomePage from "./components/routes/accounts/vendors/VHomePage";
import VPrivateRoute from "./components/routes/VPrivateRoute";
import PrivateRoute from "./components/routes/PrivateRoute";
import PublicRoute from "./components/routes/PublicRoute";
import VPublicRoute from "./components/routes/VPublicRoute";
import AppBar from "./components/nav-bar/AppBar";
import NavBar from "./components/nav-bar/NavBar";
import UserNavBar from "./components/nav-bar/UserNavBar";
import "../src/css/App.css";
import "../src/assets/account/vendor/bootstrap/css/bootstrap.min.css";
import "../src/assets/account/fonts/font-awesome-4.7.0/css/font-awesome.min.css";
import "../src/assets/account/fonts/iconic/css/material-design-iconic-font.min.css";
import "../src/assets/account/css/util.css";
import "../src/assets/account/css/main.css";
import "../src/css/pages.css";
import "../src/css/style.css";
import "../src/css/responsive.css";
import "../src/css/bootstrap.css";
import PASSTemporary from "./components/routes/accounts/users/PASSTemporary";
import VendorsTemporary from "./components/routes/accounts/vendors/VendorsTemporary";



const verifyTokenRequestUrl =
  "https://yieei7r41k.execute-api.us-east-1.amazonaws.com/prod/verify";


function App() {
 const [isAuthenticating, setAuthenticating] = useState();
  
  useEffect(() => {
    const userToken = getUserToken();
    if (
      userToken === "undefined" ||
      userToken === undefined ||
      userToken === null ||
      userToken === !userToken
    ) {
      return;
    }
     const vendorToken = getVendorToken();
     if (
       vendorToken === "undefined" ||
       vendorToken === undefined ||
       vendorToken === null ||
       vendorToken === !vendorToken
     ) {
       return;
     }

     const requestConfig = {
       headers: {
         "x-api-key": process.env.REACT_APP_API_KEY,
       },
     };
     const requestBody = {
       user: getUser(),
       token: userToken,
     };
     axios
       .post(verifyTokenRequestUrl, requestBody, requestConfig)
       .then((response) => {
         setUserSession(response.data.user, response.data.token);
         setAuthenticating(false);
       })
       .catch(() => {
         resetUserSession();
         setAuthenticating(false);
       });

       const requestBody1 = {
         vendor: getVendor(),
         token: userToken,
       };
       axios
         .post(verifyTokenRequestUrl, requestBody1, requestConfig)
         .then((response) => {
           setVendorSession(response.data.vendor, response.data.token);
           setAuthenticating(false);
         })
         .catch(() => {
           resetVendorSession();
           setAuthenticating(false);
         });

    return () => {
      
    };
  }, [])

  
  const userToken = getUserToken();
  const vendorToken = getVendorToken();
  if (isAuthenticating && userToken) {
    return (
      <div className="pass-loader-container">
        <div className="pass-loader"></div>
      </div>
    );
  }
  if (isAuthenticating && vendorToken) {
    return (
      <div className="pass-loader-container">
        <div className="pass-loader"></div>
      </div>
    );
  }

  

  return (
    <Router>
      <NavBar/>
      <Routes>
        <Route path="/" exact element={<Home />}></Route>
        <Route path="/platforms" element={<PlatformsMain />}></Route>
        <Route path="/partnerships" element={<Partnerships />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/sign-up" element={<SignUp />}></Route>
        <Route path="/pass-adashi" element={<Adashi />}></Route>
        <Route path="/pass-shopping" element={<Shopping />}></Route>
        <Route path="/pass-services" element={<Services />}></Route>
        <Route path="/pass-rentals" element={<Rentals />}></Route>
        <Route path="/pass-childcare" element={<ChildCare />}></Route>
        <Route path="/pass-health" element={<Health />}></Route>
        <Route path="/pass-shopping" element={<Shopping />}></Route>
        <Route path="/pass-feeding" element={<Feeding />}></Route>
        <Route path="/pass-travel" element={<Travel />}></Route>
        <Route path="/pass-pay" element={<Payment />}></Route>
        <Route path="pass-account" element={<PrivateRoute />}>
          <Route path="/pass-account" element={<HomePage />} />
        </Route>
        <Route path="vendor-account" element={<VPrivateRoute />}>
          <Route path="/vendor-account" element={<VHomePage />} />
        </Route>
        <Route path="/vendors/sellers" element={<Sellers />}></Route>
        <Route path="/vendors/services" element={<VServices />}></Route>
        <Route path="/vendors/properties" element={<Properties />}></Route>
        <Route path="/signin" element={<PublicRoute />}>
          <Route path="/signin" element={<SignIn />}></Route>
        </Route>
        <Route path="/signup" element={<PublicRoute />}>
          <Route path="/signup" element={<PASSTemporary />}></Route>
        </Route>
        <Route path="/vendor-signin" element={<VPublicRoute />}>
          <Route path="/vendor-signin" element={<VSignIn />}></Route>
        </Route>
        <Route path="/vendor-signup" element={<VPublicRoute />}>
          <Route path="/vendor-signup" element={<VendorsTemporary />}></Route>
        </Route>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
